export default __webpack_public_path__ + "static/media/hollow-bottom.efc039d7.svg";